import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const blindGameTabs = [
  { value: false, label: 'Обычная партия' },
  { value: true, label: 'Слепая партия' },
];

export function BlindGameInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Режим игры</FormLabel>
      <FormInput>
        <Controller
          name="isBlind"
          control={control}
          defaultValue={false}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs
              tabs={blindGameTabs}
              value={value ?? false}
              onChange={onChange}
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
